import httpService from '@/modules/common/services/httpServiceV3';

// https://vcita.free.beeceptor.com/ai/AIRecommendations
const getRecommendations = async (params) => {
  return httpService.get(`ai/ai_recommendations`, {dismissed: false, ...params}, undefined, false)
    .then((res) => {
      return res?.data?.airecommendations;
    })
    .catch((error) => {
      throw new Error('Failed to get recommendation', error);
    });
}

// https://developers.intandem.tech/v3.0/reference/put_v3-ai-ai-recommendations-uid
const updateRecommendation = async (uid, dismissed = false, dismissed_source_type = 'user') => {
  return httpService.put(`ai/ai_recommendations/${uid}`, {
    status: {
      dismissed,
      dismissed_source_type
    }
  }, false).catch((error) => {
    throw new Error('Failed to update recommendation', error);
  });
}

export default {
  getRecommendations,
  updateRecommendation,
  // getSmartReply removed - using new endpoint via POV
};
